module.exports = __webpack_public_path__ + "static/media/HamburgerMenu.cf5abdf5.svg";